import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

// The problem: React's renderToString HTML-encodes entities inside <script> text children
// (e.g., ' → &#x27;). The browser unescapes these when parsing the HTML. When React
// hydrates, the client-side text (5' x 5') doesn't match the server-rendered text
// (5&#x27; x 5&#x27;), causing a hydration failure.

function escapeForHydration(str) {
	return str
		.replaceAll('<', String.raw`\u003c`)
		.replaceAll('>', String.raw`\u003e`)
		.replaceAll("'", String.raw`\u0027`)
		.replaceAll('&', String.raw`\u0026`);
}

export default function JsonLdScript({ schema }) {
	return (
		<Helmet>
			<script type="application/ld+json">
				{escapeForHydration(
					typeof schema === 'string'
						? schema
						: JSON.stringify(schema),
				)}
			</script>
		</Helmet>
	);
}

JsonLdScript.propTypes = {
	schema: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array,
		PropTypes.string,
	]).isRequired,
};
